<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title>
        {{ $t('invoiceListOffline') }}
      </v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
<log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="storeInvoice"
          >
            <v-icon
              color="deep-green"
              style="font-size: 22px"
            >
              mdi-content-save-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('submit') }}</span>
      </v-tooltip>
      <v-tooltip
        v-if="selected.length > 0"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="deletDialog = true"
          >
            <v-icon
              color="pink"
              style="font-size: 22px"
            >
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('remove') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="showSelect = !showSelect"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              {{ (showSelect ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked-outline') }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('select-row') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mb-2">
      <v-col
        class=" px-2"
        cols="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('search')"
          solo
          flat
          clearable
          height="30"
          :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
          dense
        />
      </v-col>
    </v-row>
    <v-col
      cols="12"
      class="px-2 pt-0"
    >
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="tableHeight"
        fixed-header
        :headers="showHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="ouid"
        :hide-default-header="isMobile"
        class="td-hide-border mb-0"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageOptions: [10, 25, 50, 100, 500],
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-plus',
          nextIcon: 'mdi-minus'
        }"
      >
        <template
          v-if="isMobile"
          v-slot:item="{ item, index }"
        >
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0 "
                :class="{
                  'mobile-td-list-border-green': (item.type == 'sell' || item.type == 'presale'? true : false ),
                  'mobile-td-list-border-red': (item.type == 'purchase' ? true : false ),
                  'mobile-td-list-border-primary': (item.type == 'returnSell' || item.type == 'returnPurchase' ? true : false ),
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu
                      offset-y
                    >
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          color="primary"
                          v-bind="attrs"
                          icon
                          v-on="on"
                        >
                          <v-icon
                            medium
                          >
                            mdi-dots-vertical
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="print(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-printer-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="fishPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-paper-roll-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceRollprint')" />
                        </v-list-item>
                        <v-list-item
                          v-if="type == 'sell'"
                          link
                          @click="invoiceSms(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('sendInvoiceSMS')" />
                        </v-list-item>
                        <v-list-item
                          v-if="item.entrepot"
                          link
                          @click="entrepotPrint(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-warehouse</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t(item.entrepot.type + 'Print')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="copyInvoice(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-content-copy</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('invoiceCopy')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/' + type +'/edit/' + item.uid"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink">
                              mdi-trash-can-outline
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ (item.customer ? item.customer.name : '') }} ({{ item.number }})
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('document-number') }} : {{ item.doc_header.number }}
                    | {{ $t('id') }} : {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('discount') }} : {{ $numberFormat((item.discount ? item.discount : 0)) }}
                    | {{ $t('tax') }} : {{ $numberFormat((item.tax ? item.tax : 0)) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('date') }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-for="(integrate, index) in item.integrator"
                        :key="index"
                        color="green"
                        label
                        small
                        style="margin-left: 1px;margin-right:1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ $t('registerBy') }} : {{ $t(integrate.key) }}  | {{ $t('id') }} : {{ integrate.value }}
                          {{ (integrate.number ? ' | ' + $t('number') + ':' + integrate.number : '' ) }}
                        </span>
                      </v-chip>
                      <v-chip
                        v-if="item.payed"
                        class="ms-1"
                        :color="(parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? 'red' : 'green')"
                        small
                        outlined
                      >
                        {{ (parseFloat(item.price.price)-parseFloat(item.payed.amount) > 0 ? $t('remainPrice') + ' ' + $numberFormat(parseFloat(item.price.price)-parseFloat(item.payed.amount)) : $t('payed')) }}
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn
                    dark
                    text
                    small
                    color="primary"
                    @click="edit(item)"
                  >
                    {{ $numberFormat((item.price ? item.price.NetPrice : 0)) }} {{ item.currency.symbol }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                v-bind="attrs"
                icon
                v-on="on"
              >
                <v-icon
                  medium
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>

            <v-list dense>
<!--              <v-list-item-->
<!--                link-->
<!--                @click="edit(item)"-->
<!--              >-->
<!--                <v-list-item-icon>-->
<!--                  <v-icon>mdi-clipboard-edit</v-icon>-->
<!--                </v-list-item-icon>-->
<!--                <v-list-item-title v-text="$t('edit')" />-->
<!--              </v-list-item>-->
              <v-list-item
                link
                @click="fishPrint(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-paper-roll-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('invoiceRollprint')" />
              </v-list-item>
              <v-list-item
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.sum="{ item }">
          {{ $numberFormat(item.sum) }} {{ item.currency.symbol }}
        </template>
        <template v-slot:item.type="{ item }">
          {{ $t(item.type) }}
        </template>
        <template v-slot:item.statusOffline="{}">
          <v-chip
            class="mx-0"
            color="pink"
            small
            outlined
          >
            {{ $t('notRegister') }}
          </v-chip>
        </template>
        <!--        <template-->
        <!--          v-slot:body.append-->
        <!--        >-->
        <!--          <tr :class="{'v-data-table__mobile-table-row':isMobile}">-->
        <!--            <td-->
        <!--              :colspan="`${isMobile?6:Number(showHeaders.length) - 14 + (type !== 'sell' ? 1 : 0)}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            >-->
        <!--              <strong>{{ $t('sum') }}</strong>-->
        <!--            </td>-->
        <!--            <td-->
        <!--              :colspan="`${isMobile?6:1}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            >-->
        <!--              {{ (isMobile ? $t('sumNetAmount') + ':' : '') }} {{ $numberFormat(totals.sumNetAmount) }}-->
        <!--            </td>-->
        <!--            <td-->
        <!--              :colspan="`${isMobile?6:1}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            >-->
        <!--              {{ (isMobile ? $t('discount') + ':' : '') }} {{ $numberFormat(totals.discount) }}-->
        <!--            </td>-->
        <!--            <td-->
        <!--              :colspan="`${isMobile?6:1}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            >-->
        <!--              {{ (isMobile ? $t('tax') +':': '') }}  {{ $numberFormat(totals.tax) }}-->
        <!--            </td>-->
        <!--            <td-->
        <!--              :colspan="`${isMobile?6:1}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            >-->
        <!--              {{ (isMobile ? $t('price') + ':' : '') }} {{ $numberFormat(totals.price) }}-->
        <!--            </td>-->
        <!--            <td-->
        <!--              v-if="!isMobile"-->
        <!--              :colspan="`${isMobile?6:5}`"-->
        <!--              :class="{'v-data-table__mobile-row':isMobile}"-->
        <!--            />-->
        <!--          </tr>-->
        <!--        </template>-->
      </v-data-table>
    </v-col>
    <v-row />
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="invoicePrintDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="invoicePrintDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <invoicprint
            :id-prop="printId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
      :draggable="true"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="account"
              :title="$t('customer')"
              type="person"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <status
              v-model="sellStatus"
              :hideconfig="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="currencyFilter"
              :title="$t('currency')"
              type="currency"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="fromAmount"
              :dense="true"
              :label="$t('from') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="fromNumber"
              :label="$t('from') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <money
              v-model="toAmount"
              :dense="true"
              :label="$t('until') + ' ' + $t('amount')"
              :outlined="true"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="toNumber"
              :label="$t('until') + ' ' + $t('number')"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="category"
              :title="$t('category')"
              type="accountCategory"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="branch"
              title="branch"
              type="branch"
              :filter="true"
              :multiple="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <autocomplete
              v-model="entrepot"
              title="entrepot"
              type="entrepot"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0">
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              class="pa-0 py-1"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="invoice"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import Invoicprint from './print'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  export default {
    name: 'InvoiceListOffline',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Upload,
      Invoicprint,
      Print,
      Task,
    },
    mixins: [General],
    props: ['input', 'refId', 'typeProp', 'accountProp'],
    data: () => ({
      selected: [],
      invoicePrintDialog: false,
      printDialog: false,
      deletDialog: false,
      uploadDialog: false,
      dialogData: null,
      entrepot: null,
      category: null,
      account: null,
      currencyFilter: null,
      fromAmount: null,
      toAmount: null,
      fromNumber: null,
      toNumber: null,
      fromDate: null,
      toDate: null,
      printId: null,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: false,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      excelItems: [],
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
      // totals: function () {
      //   // var total = this.items.map(function (value, key) {
      //   //   app.remove(value, key)
      //   // })
      //   var app = this
      //   app.excelItems = []
      //   const totals = this.items.reduce((acc, d) => {
      //     acc.sumNetAmount += parseFloat(d.sum) + parseFloat(d.discount) - parseFloat(d.tax)
      //     acc.price += parseFloat(d.sum)
      //     acc.discount += parseFloat(d.discount)
      //     acc.tax += parseFloat(d.tax)
      //     app.excelItems.push({
      //       id: d.id,
      //       type: app.$t(d.type),
      //       number: d.number,
      //       customer: (d.customer ? d.customer.name : null),
      //       date: d.date,
      //       price: app.$numberFormat((d.price ? d.price.price : 0)),
      //       discount: app.$numberFormat(d.discount),
      //       tax: app.$numberFormat(d.tax),
      //       warehouse: (d.entrepot ? d.entrepot.entrepot.name : ''),
      //       payment: (d.payed ? app.$numberFormat(d.payed.amount) : ''),
      //       integrator: (d.integrator && d.integrator.length > 0 ? app.$t(d.integrator[0].key) + ' = ' + d.integrator[0].value + ' | ' + d.integrator[0].number : ''),
      //       user: (d.user ? d.user.name : ''),
      //     })
      //     return acc
      //   }, {
      //     sumNetAmount: 0,
      //     price: 0,
      //     discount: 0,
      //     tax: 0,
      //   })
      //   return totals
      // },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      accountProp (val) {
        this.getItems()
      },
    },
    activated () {
    // this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'purchaseList') {
        this.type = 'purchase'
      }
      if (this.$route.name === 'presaleList') {
        this.type = 'presale'
      }
      if (this.$route.name === 'sellList') {
        this.type = 'sell'
      }
      if (this.$route.name === 'returnPurchaseList') {
        this.type = 'returnPurchase'
      }
      if (this.$route.name === 'returnSellList') {
        this.type = 'returnSell'
      }
      if (this.typeProp) {
        this.type = this.typeProp
      }
      this.headers = [
        {
          text: this.$t('actions'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 20,
        },
        {
          text: this.$t('row'),
          align: 'start',
          sortable: false,
          value: 'row',
          width: 20,
        },
        {
          text: this.$t('ouid'),
          sortable: false,
          value: 'ouid',
          width: 80,
        },
        {
          text: this.$t('type'),
          sortable: false,
          value: 'type',
          width: 80,
        },
        {
          text: this.$t('customer'),
          sortable: false,
          value: 'account.name',
          width: 80,
        },
        {
          text: this.$t('date'),
          sortable: false,
          value: 'date',
          width: 80,
        },
        {
          text: this.$t('amount'),
          sortable: false,
          value: 'sum',
          width: 80,
        },
        {
          text: this.$t('status'),
          sortable: false,
          value: 'statusOffline',
          width: 80,
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
      this.getItems()
    },
    methods: {
      openUploadDialog (item) {
        this.uploadDialog = true
      },
      copyInvoice (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice/' + item.uid + '/edit', {
          params: {
            id: item.uid,
          },
        })
          .then(res => {
            res = res.data
            app.$router.push({ name: app.type, params: { itemsProp: res.article } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      entrepot_ (item) {
        this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'invoiceCasherEdit', params: { id: item.ouid, tabName: item.number } })
      },
      print (item) {
        this.$router.push({ name: 'invoicePrint', params: { id: item.uid, tabName: item.number } })
      // this.printId = item.uid
      // this.invoicePrintDialog = true
      },
      fishPrint (item) {
        this.$router.push({ name: 'invoiceRollprint', params: { id: item.ouid, offlineProp: true } })
      },
      entrepotPrint (item) {
        this.$router.push({ name: item.entrepot.type + 'Print', params: { id: item.entrepot.id } })
      },
      storeInvoice () {
        var app = this
        app.loading = true
        this.createInvoiceOffline()
        setTimeout(function () {
          app.getItems()
          app.loading = false
        }, app.items.length * 4000)
      },
      getItems () {
        var list = JSON.parse(localStorage.getItem('invoice'))
        if (list) {
          this.items = list
          this.totalItems = list.length
          this.from = 1
        }
      },
      invoiceSms (item) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'invoice', {
          params: {
            invoiceSMS: 'active',
            id: item.id,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarColor = 'green'
            app.snakbarText = this.$t('sent')
            app.snakbar = true
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var list = JSON.parse(localStorage.getItem('invoice'))
        var i = list.findIndex(obj => obj.ouid === this.deleteItem.ouid)
        list.splice(i, 1)
        localStorage.setItem('invoice', JSON.stringify(list))
        this.deleteItem = null
        this.getItems()
      },
      removegroup () {
        var app = this
        app.loading = true
        var list = JSON.parse(localStorage.getItem('invoice'))
        app.selected.map(function (value, key) {
          var i = list.findIndex(obj => obj.ouid === value.ouid)
          if (i > -1) {
            list.splice(i, 1)
          }
        })
        localStorage.setItem('invoice', JSON.stringify(list))
        app.selected = []
        this.getItems()
      },
    },
  }
</script>

<style scoped>

</style>
